export function getRangeType(book) {
  return book.format === "pbk" ? "page_index" : "cfi";
}

export function getType(book) {
  return book.format;
}
